import { useState } from "react";
import Card from "../../components/Card";
import ImageInput from "../../components/ImageInput";
import Loader from "../../components/Loader";
import TextInput from "../../components/TextInput";
import { InputController } from "../../hooks/input-controller";
import { UseApi } from "../../hooks/use-api";
import { ToastEmitter } from "../../Services/assets/toast-emitter";
import styles from "./Category.module.sass";
import cn from "classnames";
import { EditCategory as edit } from "../../Services/lib/admin";
import { useUser } from "../../context";
import category from "../../i11/Category";

const EditCategory = ({ close_, initial }) => {
	const { locale } = useUser();
	const [{ isLoading }, create] = UseApi({
		service: edit,
	});

	const [imgL, setL] = useState(false);

	const onSubmit = async (e) => {
		e.preventDefault();
		if (imgL) {
			ToastEmitter({
				msg: "Image is uploading, please wait",
				type: "info",
			});
		} else {
			const tmp = { ...body };
			if (tmp.image.core_image_url) {
				tmp.image = tmp.image.core_image_url;
			}
			const res = await create(tmp);
			if (res) {
				close_();
				ToastEmitter({
					type: "success",
					msg: "Successfully edited a category",
				});
			}
		}
	};

	const [body, setBody] = useState(initial);
	const title = InputController("title", setBody);
	const description = InputController("description", setBody);
	const prior = InputController("prior", setBody);

	const HandleChange = (e) => {
		setBody((p) => {
			return {
				...p,
				image: e,
			};
		});
	};

	return (
		<Card
			className={styles.edit}
			title={category[locale].edit_category}
			classTitle="title-purple"
		>
			<form onSubmit={onSubmit} className={styles.form}>
				<TextInput
					defaultValue={initial.title}
					className={styles.field}
					label={category[locale].name}
					name="title"
					type="text"
					tooltip="Enter category name"
					required
					{...title}
				/>
				<TextInput
					defaultValue={initial.description}
					className={styles.field}
					label={category[locale].description}
					name="description"
					type="text"
					tooltip="Enter category description"
					required
					textarea
					{...description}
				/>
				<TextInput
					defaultValue={initial.prior}
					className={styles.field}
					label={category[locale].prior}
					name="Priority"
					type="number"
					tooltip="Enter category name"
					required
					{...prior}
				/>
				<ImageInput
					where="CATEGORYS"
					callBack={HandleChange}
					className={styles.field}
					initial={initial.image}
					label={category[locale].image}
					required
					tooltip="Image"
					setL={setL}
				/>

				<div className={styles.field}>
					<button className={cn("button", { disabled: isLoading })}>
						{isLoading && <Loader />}
						{category[locale].save}
					</button>
				</div>
			</form>
		</Card>
	);
};

export default EditCategory;
